import { jsx as a, jsxs as o, Fragment as u } from "react/jsx-runtime";
import { ChevronRightLineIcon as g, CloseLineIcon as h } from "@ifrc-go/icons";
import { _ as r } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import w from "../InlineLayout/index.js";
import C from "../../hooks/useSpacingToken.js";
import '../../index61.css';const T = "_tab-wrapper_9q0s6_1", P = "_active-border_9q0s6_7", W = "_active_9q0s6_7", x = "_bottom-border_9q0s6_18", B = "_tab-layout_9q0s6_24", I = "_errored_9q0s6_40", j = "_color-variant-text_9q0s6_44", F = "_color-variant-primary_9q0s6_48", O = "_color-variant-secondary_9q0s6_52", k = "_style-variant-tab_9q0s6_56", A = "_style-variant-nav_9q0s6_77", R = "_style-variant-pill_9q0s6_87", z = "_style-variant-vertical_9q0s6_98", D = "_style-variant-vertical-compact_9q0s6_115", E = "_forward-icon_9q0s6_123", G = "_style-variant-step_9q0s6_137", H = "_completed_9q0s6_146", J = "_disabled_9q0s6_174", K = "_step-wrapper_9q0s6_221", M = "_dot_9q0s6_226", Q = "_icon_9q0s6_236", U = "_dot-wrapper_9q0s6_247", X = "_before-line_9q0s6_252", Y = "_after-line_9q0s6_261", Z = "_first-step_9q0s6_294", $ = "_last-step_9q0s6_307", t = {
  tabWrapper: T,
  activeBorder: P,
  active: W,
  bottomBorder: x,
  tabLayout: B,
  errored: I,
  colorVariantText: j,
  colorVariantPrimary: F,
  colorVariantSecondary: O,
  styleVariantTab: k,
  styleVariantNav: A,
  styleVariantPill: R,
  styleVariantVertical: z,
  styleVariantVerticalCompact: D,
  forwardIcon: E,
  styleVariantStep: G,
  completed: H,
  disabled: J,
  stepWrapper: K,
  dot: M,
  icon: Q,
  dotWrapper: U,
  beforeLine: X,
  afterLine: Y,
  firstStep: Z,
  lastStep: $
}, tt = {
  text: t.colorVariantText,
  primary: t.colorVariantPrimary,
  secondary: t.colorVariantSecondary
}, at = {
  tab: t.styleVariantTab,
  pill: t.styleVariantPill,
  step: t.styleVariantStep,
  nav: t.styleVariantNav,
  vertical: t.styleVariantVertical,
  "vertical-compact": t.styleVariantVerticalCompact
}, et = {
  tab: 1,
  pill: 0,
  step: -1,
  nav: 0,
  vertical: 0,
  "vertical-compact": -2
};
function lt(p) {
  const {
    colorVariant: _ = "primary",
    styleVariant: e = "nav",
    spacingOffset: d = et[e],
    className: m,
    disabled: v,
    children: y,
    withoutPadding: V = !1,
    active: s,
    spacing: b,
    tabWrapperClassName: f,
    stepCompleted: n,
    isFirstStep: q,
    isLastStep: N,
    errored: c,
    after: S,
    ...L
  } = p, l = C({
    modes: ["padding-inline"],
    spacing: b,
    offset: -5
  }), i = /* @__PURE__ */ a(
    w,
    {
      ...L,
      withPadding: !(V || e === "vertical-compact" || e === "nav"),
      className: r(
        t.tabLayout,
        tt[_],
        at[e],
        n && t.completed,
        v && t.disabled,
        s && t.active,
        c && t.errored,
        m
      ),
      spacingOffset: d,
      withAdditionalInlinePadding: e === "pill",
      after: /* @__PURE__ */ o(u, { children: [
        S,
        e === "vertical-compact" && /* @__PURE__ */ a(g, { className: t.forwardIcon })
      ] }),
      children: y
    }
  );
  return e === "tab" ? /* @__PURE__ */ o(
    "div",
    {
      className: r(
        t.tabWrapper,
        f,
        s && t.active
      ),
      children: [
        /* @__PURE__ */ a("div", { className: r(t.bottomBorder, l) }),
        i,
        /* @__PURE__ */ a("div", { className: r(t.bottomBorder, l) }),
        s && /* @__PURE__ */ a("div", { className: t.activeBorder })
      ]
    }
  ) : e === "step" ? /* @__PURE__ */ o(
    "div",
    {
      className: r(
        t.stepWrapper,
        s && t.active,
        n && t.completed,
        q && t.firstStep,
        N && t.lastStep
      ),
      role: "tab",
      children: [
        /* @__PURE__ */ o("div", { className: t.dotWrapper, children: [
          /* @__PURE__ */ a("div", { className: t.beforeLine }),
          /* @__PURE__ */ a("div", { className: t.dot, children: c && /* @__PURE__ */ a(h, { className: t.icon }) }),
          /* @__PURE__ */ a("div", { className: t.afterLine })
        ] }),
        i
      ]
    }
  ) : i;
}
export {
  lt as default
};
